import { p as palette } from '../base/color-DMp1DFwP.js';
import { t as typography } from '../base/typography-j1qfCKl5.js';

const labelStyles = {
  color: typography.color.primary,
  colorDisabled: palette.gray[700],
  weight: '700',
  paddingBottom: '2px'
};

export { labelStyles as l };
//# sourceMappingURL=label-gn2VuZlQ.js.map
